/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Guide_IntroInputs */

const en_landing_guide_intro = /** @type {(inputs: Landing_Guide_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ideogram 4.5 is the September 2026 release of Ideogram's image model, and it changes what matters in an image tool. Generating a first draft is easy; keeping that draft intact while you refine it is not. This release was built for the refining. This guide covers what the model does, how drift-free editing works, where it is most useful and how to get clean results in this workspace.`)
};

const zh_landing_guide_intro = /** @type {(inputs: Landing_Guide_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ideogram 4.5 是 Ideogram 在 2026 年 9 月发布的图像模型，它改变了衡量图像工具的标准。生成第一版草图很容易，难的是在反复打磨时保持草图不走样。Ideogram AI 4.5 正是为打磨而生。本指南介绍这个模型能做什么、无漂移编辑如何实现、最适合哪些场景，以及如何在本工作台获得干净的结果。`)
};

/**
* | output |
* | --- |
* | "Ideogram 4.5 is the September 2026 release of Ideogram's image model, and it changes what matters in an image tool. Generating a first draft is easy; keeping..." |
*
* @param {Landing_Guide_IntroInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_guide_intro = /** @type {((inputs?: Landing_Guide_IntroInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Guide_IntroInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_guide_intro(inputs)
	return zh_landing_guide_intro(inputs)
});
export { landing_guide_intro as "landing.guide.intro" }